interface MetricCardProps {
  label: string;
  value: string;
  /** Optional percentage change vs previous period. */
  change?: number;
  /** When true, a positive change is good (green); when false, inverted. */
  positiveIsGood?: boolean;
}

export function MetricCard({ label, value, change, positiveIsGood = true }: MetricCardProps) {
  const showChange = change !== undefined;
  const isUp = (change ?? 0) >= 0;
  const isGood = positiveIsGood ? isUp : !isUp;

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <p className="text-sm text-gray-500">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-gray-900">{value}</p>
      {showChange && (
        <p className={`mt-1 text-sm font-medium ${isGood ? 'text-green-600' : 'text-red-600'}`}>
          {isUp ? '▲' : '▼'} {Math.abs(change ?? 0).toFixed(1)}%
          <span className="ml-1 font-normal text-gray-400">față de perioada anterioară</span>
        </p>
      )}
    </div>
  );
}
